import { playerMetricsAtom } from '@/atoms/metric/playerMetrics';
import { loadable } from '@/utils/jotai';
import { radarDataAtom } from '../radar';
import { playerRadarTableColumnsAtom } from '../tableColumns';
import { playerRadarTemplatesAtom } from '../userConfigs';
import { rawPlayerRadarDataAtom } from './playerRadarData';

export const loadablePlayerRadarDataAtom = loadable(
  radarDataAtom(rawPlayerRadarDataAtom, playerMetricsAtom, playerRadarTemplatesAtom, playerRadarTableColumnsAtom),
);
